(function () {
    if (typeof EmblaCarousel === 'undefined') {
        return;
    }

    document.querySelectorAll('.gh-header-carousel.embla').forEach(function (carouselNode) {
        var shellNode = carouselNode.closest('.gh-header-carousel-shell');
        var viewportNode = carouselNode.querySelector('.embla__viewport');
        var prevButton = shellNode && shellNode.querySelector('.embla__prev');
        var nextButton = shellNode && shellNode.querySelector('.embla__next');
        var slides = carouselNode.querySelectorAll('.embla__slide');

        if (!viewportNode || slides.length === 0) {
            carouselNode.remove();
            return;
        }

        var plugins = [];

        if (typeof EmblaCarouselAutoplay !== 'undefined' && slides.length > 1) {
            plugins.push(EmblaCarouselAutoplay({
                delay: 5000,
                stopOnInteraction: false
            }));
        }

        var embla = EmblaCarousel(viewportNode, {
            loop: slides.length > 1,
            align: 'start',
            containScroll: 'trimSnaps'
        }, plugins);

        if (slides.length === 1) {
            if (prevButton) {
                prevButton.hidden = true;
            }

            if (nextButton) {
                nextButton.hidden = true;
            }

            return;
        }

        if (prevButton) {
            prevButton.addEventListener('click', function () {
                embla.scrollPrev();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function () {
                embla.scrollNext();
            });
        }
    });
})();
